<template>
  <v-dialog v-model="dialogStatus"
            persistent
            max-width="800px">
    <div class="fill-height">


      <v-card class="fill-height">

        <v-card-subtitle>تعریف/ویرایش قالب پیامک ثبت سند</v-card-subtitle>
        <v-spacer/>


        <v-card-text>


          <v-form  ref="form" @submit.prevent="save" lazy-validation v-model="valid">
            <v-row>

              <v-col
                  cols="12"
                  sm="6"
                  md="4" >

              <v-text-field  dense label="عنوان" v-model="localModel.title" outlined/>

              </v-col>
              <v-col
                  cols="12"
                  sm="6"
                  md="3">

                <v-autocomplete
                    :items="buildingList"
                    v-model="localModel.buildingId"
                    label="انتخاب مجتمع"
                    dense
                    outlined
                    :error-messages="getError('buildingId')"
                />
              </v-col>
              <v-col
                  cols="12"
                  sm="3"
                  v-for="item in itemList "
                  :key="item.value"
              >
                <v-btn
                    block
                    :disabled=" localModel.message.includes('#' + item.value+'#')"
                    small
                    depressed
                    color="info"
                    class=" p-1 m-1"
                    @click="appendSms(item.value)"
                >
                 {{item.text}}
                </v-btn>
              </v-col>
              <v-col
                  cols="12"
                  sm="12"
                  md="12">
                <v-textarea
                    ref="smsTextarea"
                    label="متن پیام"
                    outlined
                    @click="saveCursorPosition"
                    @keyup="saveCursorPosition"
                    dense
                    :error-messages="getError('message')"
                    v-model="localModel.message"
                />
                <span  style="float: left!important;font-size: 14px!important;" class="text-caption black--text">
                  تعداد کاراکتر: {{ messageStats.length }} |
                  تعداد پیامک: {{ messageStats.smsCount }}
                </span>
              </v-col>

            </v-row>

            <v-divider class="p-0 m-0"/>
            <v-card-actions dir="ltr">

              <v-btn
                  depressed
                  small
                  color="primary"
                  class=" p-1 m-1"
                  type="submit"
                  :loading="loading">
                ذخیره
              </v-btn>
              <v-btn
                  depressed
                  small
                  color="error"
                  class=" p-1 m-1"
                  @click="closed"
              >
                لغو
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import Service_se from "./Service_se";



export default {

  props: {
    dialogStatus: {
      default: false,
    },
    value: {
      type: Object,
      required: true
    },
    buildingList: {
      type: Array,
      default: () => []
    },
    itemList: {
      type: Array,
      default: () => []
    },
    audienceList: {
      type: Array,
      default: () => []
    }

  },
  data() {
    return {
      cursorPos: 0,
      baseMessage: this.value.message || '',
      bindingErrors: [],
      valid: true,
      loading: false,
    }
  },

  computed: {
    localModel: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    messageStats() {
      const message = this.localModel.message || '';
      const length = message.length;
      // تخمین تعداد پیامک بر اساس طول پیام (فرض: فارسی، 70 کاراکتر اول، بعدش 67تایی)
      let smsCount = 0;
      if (length > 0) {
        if (length <= 70) {
          smsCount = 1;
        } else {
          smsCount = Math.ceil((length - 70) / 67) + 1;
        }
      }

      return {
        length,
        smsCount
      };
    },

  },


  methods: {
    handleInput (value) {
      this.$emit('input', value)
    },

    getError(key) {
      if (this.bindingErrors && this.bindingErrors.length > 0) {
        let error = this.bindingErrors.find( ({ fieldName }) => fieldName === key );
        if(error && error.message ) return  error.message[0]
      }
      return ''
    },
    closed() {
      this.bindingErrors=[]
      this.$root.$emit('DailyAccountSms')
      this.loading=false
      this.$emit('update:dialogStatus', false)
    },
    saveCursorPosition() {
      const textarea = this.$refs.smsTextarea?.$el.querySelector('textarea')
      if (textarea) {
        this.cursorPos = textarea.selectionStart
      }
    },
    appendSms(val) {
      const token = `#${val}#`
      const msg = this.localModel.message || ''
      const pos = this.cursorPos || 0

      // جلوگیری از تکرار
      if (msg.includes(token)) return

      this.localModel.message =
          msg.slice(0, pos) + token + msg.slice(pos)

      // آپدیت cursor بعد از insert
      this.$nextTick(() => {
        const textarea = this.$refs.smsTextarea.$el.querySelector('textarea')
        if (textarea) {
          const newPos = pos + token.length
          textarea.setSelectionRange(newPos, newPos)
          textarea.focus()
          this.cursorPos = newPos
        }
      })
    },

    save(){
      this.loading=true
      this.bindingErrors = []
      Service_se.save(this.localModel).then(response => {
          if (response && response.status === 200) {
            this.$snack({type: 'success'})
            this.closed()
          }else if (response && response.response.status === 400) {
            this.loading=false
            this.bindingErrors = response.response.data;
          }
        })

    },

  },



}
</script>


